module.exports = __webpack_public_path__ + "img/environment.ab9d7389.svg";